import React from 'react';
import { useNavigate } from 'react-router-dom';
import qs from 'qs';
import { deleteDataRequest } from 'utils/request';
import TextField from 'components/TextField';
import ROUTE_PATH from 'routes/config';

const AccountIdField = ({
  accountType,
  interlockDetailData,
  setModalData,
  runAfterConfirm,
}) => {
  const navigate = useNavigate();
  const {
    mainMallId = '',
    subMallId = '',
    businessDataProviderMallMappingSeq = 0,
    mallSeq = '',
    mallName = '',
    mallInterlockStatusTypeCd = '',
    interlockOpenYn = '',
  } = interlockDetailData;
  const isShowTextField =
    (accountType === 'main' && mainMallId) ||
    (accountType === 'sub' && subMallId);

  // 등록/수정 버튼 클릭
  const onClickRegisterModifyBtn = mode => {
    // 부계정이 존재하는 경우: 주계정 수정 불가
    if (subMallId && accountType === 'main' && mode === 'modify') {
      setModalData({
        contents:
          '현재 부계정으로 판매몰의 정산 예정 금액이 스크래핑되고 있어 주계정 정보를 수정할 수 없습니다. 수정이 필요하신 경우 1:1 문의를 이용해 주세요.',
        confirmBtnName: '확인',
        onClickConfirmBtn: () => {
          setModalData(null);
        },
        cancelBtnName: '1:1 문의하기',
        onClickCancelBtn: () => {
          navigate(`${ROUTE_PATH.serviceCenter.qnaListPage}?tab=QnA`);
        },
      });
      return;
    }

    runAfterConfirm({
      confirmFnc: () => {
        const queryString = qs.stringify({
          mode,
          seq: businessDataProviderMallMappingSeq,
          mallSeq: mallSeq,
          type: accountType,
        });
        // 데이터 연동 페이지로 이동
        navigate(
          `${ROUTE_PATH.mypage.dataLinkageDataInterlockRequest}?${queryString}`
        );
      },
      confirmMsg: `현재 연동이 중지된 상태입니다. 계정 정보를 ${
        mode === 'register' ? '등록' : '수정'
      }하면 연동이 자동으로 다시 시도되어 연동 중지 상태가 해제됩니다. 계정 정보를 ${
        mode === 'register' ? '등록' : '수정'
      }하시겠습니까?`,
    });
  };

  // 삭제 버튼 클릭
  const onClickDeleteBtn = () => {
    setModalData({
      contents: `${mallName}의 부계정을 삭제 하시겠어요?\n주계정으로 연동이 불가한 경우, 부계정 삭제 시 판매몰 연동이 실패될 수 있어요.`,
      confirmBtnName: '확인',
      cancelBtnName: '취소',
      onClickConfirmBtn: onClickModalConfirmBtn,
    });
  };

  // 삭제 모달 확인 버튼
  const onClickModalConfirmBtn = () => {
    deleteDataRequest({
      url: `v1/au/data-provider-mall/interlock-sub-mall/${businessDataProviderMallMappingSeq}`,
      successFnc: () => {
        window.location.reload();
        setModalData(null);
      },
      errorFnc: message => {
        setModalData({ contents: message });
      },
    });
  };

  // 판단기준: 주계정/부계정, 부계정 데이터가 있는지
  const makeActionBtn = () => {
    return (
      <dd className="buttonGroup">
        {(accountType === 'main' || (accountType === 'sub' && subMallId)) && (
          <button
            name="수정"
            type="button"
            onClick={() => onClickRegisterModifyBtn('modify')}
            disabled={
              interlockOpenYn === 'Y' && mallInterlockStatusTypeCd === 'WAIT'
            }
          >
            수정
          </button>
        )}
        {accountType === 'sub' && subMallId && (
          <button name="삭제" type="button" onClick={onClickDeleteBtn}>
            삭제
          </button>
        )}
        {accountType === 'sub' && !subMallId && (
          <button
            name="등록"
            type="button"
            onClick={() => onClickRegisterModifyBtn('register')}
            disabled={
              interlockOpenYn === 'Y' && mallInterlockStatusTypeCd === 'WAIT'
            }
          >
            등록
          </button>
        )}
      </dd>
    );
  };

  return (
    <dl>
      <dt>{accountType === 'main' ? '주계정' : '부계정'}</dt>
      {isShowTextField && (
        <dd>
          <TextField
            name={`${accountType}MallId`}
            type="text"
            value={interlockDetailData[`${accountType}MallId`]}
            readOnly
            style={{ margin: 0 }}
          />
        </dd>
      )}
      {makeActionBtn()}
    </dl>
  );
};

export default AccountIdField;
